// extracted by mini-css-extract-plugin
export default {"price":"c0-z","onSale":"d0-z","msrpLabelPrice":"e0-z","originalPrice":"f0-z","msrpLabel":"g0-z","percentOff":"h0-z"};